"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductHeadOptionsContextProvider = exports.useProductHeadOptions = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var ProductHeadOptionsContext = /*#__PURE__*/_react["default"].createContext();
var ProductHeadOptionsContextProvider = function ProductHeadOptionsContextProvider(props) {
  var _useState = (0, _react.useState)(null),
    activeProduct = _useState[0],
    setActiveProduct = _useState[1];
  var _useState2 = (0, _react.useState)(null),
    activePicker = _useState2[0],
    setActivePicker = _useState2[1];
  var updateActiveProduct = function updateActiveProduct(product) {
    setActiveProduct(product);
  };
  var updateActivePicker = function updateActivePicker(product) {
    setActivePicker(product);
  };
  return __jsx(ProductHeadOptionsContext.Provider, {
    value: {
      updateActiveProduct: updateActiveProduct,
      activeProduct: activeProduct,
      activePicker: activePicker,
      updateActivePicker: updateActivePicker
    }
  }, props.children);
};
exports.ProductHeadOptionsContextProvider = ProductHeadOptionsContextProvider;
var useProductHeadOptions = function useProductHeadOptions() {
  return (0, _react.useContext)(ProductHeadOptionsContext);
};
exports.useProductHeadOptions = useProductHeadOptions;
var _default = ProductHeadOptionsContextProvider;
exports["default"] = _default;